import { Directive } from "@angular/core";
import { LogCat, LogManager } from "../../../log";

@Directive({
	selector: '[cpVerticalListScrollableItem]'
})
export class VerticalListScrollableItemDirective {
	constructor() {
		LogManager.debug(LogCat.UI.default,"VerticalListScrollableItemDirective.constructor");
	}
}

